module.exports = __webpack_public_path__ + "static/media/home_page_banner@768.5f6d82e5.png";